import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { RetailOrderDetails } from '../types/RetailOrderDetails';

export const useGetRetailOrder = (retailOrderID?: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        enabled: !!retailOrderID,
        queryKey: ['retail-order', retailOrderID],
        queryFn: async () => await apiClient.get('retail-order/dealer-details',
            {
                params: {
                    retailOrderID: retailOrderID
                }
            }) as RetailOrderDetails
    });

    return {
        data,
        isLoading: isLoading && !!retailOrderID,
        refetch,
        isRefetching
    };
};
